// import { ArrowBack } from "@mui/icons-material";
import Button from "@mui/material/Button";
import Stack from "@mui/material/Stack";
import TextField from "@mui/material/TextField";
import React from "react";

const SupportForm = () => {
  return (
    <Stack direction='column' spacing={2}>
      <TextField fullWidth label='Title' id='title' multiline rows={3} />
      <TextField
        fullWidth
        label='Short Description'
        id='short_description'
        multiline
        rows={3}
      />
      <TextField
        fullWidth
        label='Description'
        id='description'
        multiline
        rows={3}
      />
      <Stack direction='row' spacing={2}>
        <Button variant='contained' sx={{ padding: 1 }} disabled>
          SAVE
        </Button>
        <Button variant='contained' sx={{ padding: 1 }} color='error'>
          CANCEL
        </Button>
      </Stack>
    </Stack>
  );
};

export default SupportForm;
